import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
	selector: 'app-mail-preview-dialog',
	standalone: true,
	imports: [MatDialogModule],
	template: `<h2 mat-dialog-title>Temat: {{ data.subject }}</h2>

		<mat-dialog-content>
			<div class="mail-body" [innerHTML]="data.message"></div>
		</mat-dialog-content> `,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MailPreviewDialogComponent {
	readonly data = inject(MAT_DIALOG_DATA);
}
